import useCalcItemPrice from '@package/utils/src/useCalcItemPrice';
import { Fragment } from 'react';
import config from 'config-base';
import styles from './SearchResultsPrice.module.css';
import { SearchResultsPriceProps } from './types';
import clsx from 'clsx';

const SearchResultsPrice = ({
  priceCents,
  pricePerUnit,
  pricePerUnitLabel,
  ProductConditionMax,
  salePriceCents,
  NewPriceMax,
  NewPriceMin,
  NewSalePriceMax,
  NewSalePriceMin,
  UsedAnyPriceMin,
}: SearchResultsPriceProps) => {
  const { getSalesPrice, getOriginalPrice, getProductConditionalPrice, isRefurbished } = useCalcItemPrice({
    newPriceMin: NewPriceMin || null,
    newPriceMax: NewPriceMax || null,
    newSalePriceMin: NewSalePriceMin || null,
    newSalePriceMax: NewSalePriceMax || null,
    productConditionMax: ProductConditionMax || null,
    priceCents,
    salePriceCents,
    UsedAnyPriceMin,
  });

  const renderWithPricePerUnit = () =>
    pricePerUnit && <span className={styles.rdLabel}>{` ${pricePerUnit} ${pricePerUnitLabel!}`}</span>;

  const renderSalesPrice = (salesPrice: string | null | undefined) => {
    return (
      salePriceCents && (
        <p
          className={clsx(styles.searchItemPrice, {
            [styles.searchItemPriceAgd]: config.brandCode !== '0',
          })}
        >
          {salesPrice}
          {renderWithPricePerUnit()}
        </p>
      )
    );
  };

  const renderOriginalPrice = (
    originalPrice: string | null | undefined,
    productConditionPrice: string | null | undefined,
  ) => {
    if (isRefurbished && productConditionPrice) {
      return (
        <span
          className={clsx(styles.rdLabel, styles.originalPrice, styles.refurbPrice, {
            [styles.refurbPriceAgd]: config.brandCode !== '0',
          })}
        >{`${ProductConditionMax!}. ${productConditionPrice}`}</span>
      );
    } else {
      return (
        <>
          {originalPrice ? (
            <span
              className={clsx(styles.rdLabel, styles.originalPrice, styles.refurbPrice, {
                [styles.refurbPriceAgd]: config.brandCode !== '0',
              })}
            >
              <span>{originalPrice}</span>
            </span>
          ) : null}
        </>
      );
    }
  };

  const renderSearchResultsPrice = () => {
    const salesPrice = getSalesPrice();
    const originalPrice = getOriginalPrice();
    const productConditionPrice = getProductConditionalPrice();
    return (
      <Fragment>
        {renderSalesPrice(salesPrice)}
        {renderOriginalPrice(originalPrice, productConditionPrice)}
      </Fragment>
    );
  };

  return <>{renderSearchResultsPrice()}</>;
};

export default SearchResultsPrice;
